






































































































































































































































































import { Component, Watch, Mixins } from "vue-property-decorator";
import dayjs from "dayjs";
import { BvModalEvent, BvMsgBoxOptions } from "bootstrap-vue";
import { VIPCapabilityEditViewMixin } from "@/mixins/VIPCapabilityMixin";
import {
	db,
	auth,
	busy,
	toaster,
	settings,
	IpRuleType,
	VIPCapability,
	VIPCertificate,
	VipCapabilityStatus,
	VipCapabilityType,
	VIPCapabilityRest,
	VIPCapabilityCertificateRest,
	VIPCapabilityEventRest,
	VIPCertificateRest,
	VipCertificateType,
	getVipCapabilityTypeLabel,
	VIPCapabilityCertificate,
	createEventInfo,
	VipEventType,
	IRestResult,
} from "@/loader";
import IpRule from "../component/ip/IpRule.vue";
import IpTree from "../component/ip/IpTree.vue";
import EventsSidebar from "../component/event/EventsSidebar.vue";
import CertificatesTable from "../component/certificate/CertificatesTable.vue";
import CertificatePdfModal from "../component/certificate/CertificatePdfModal.vue";
import CapabilityStatusBadge from "../component/capability/CapabilityStatusBadge.vue";

@Component({
	name: "CapabilityView",
	components: {
		IpRule,
		IpTree,
		EventsSidebar,
		CertificatesTable,
		CertificatePdfModal,
		CapabilityStatusBadge,
	}
})
export default class CapabilityView extends Mixins(VIPCapabilityEditViewMixin({
	redirection: { name: "Capabilities" },
	loadMessage: "Chargement de la capacité ...",
	getParams: {
		options: {
			capability_request: true,
			certificates: {
				certificate: {
					project: true,
					ips: true,
				},
			},
			events: { event: true },
		},
	},
})) {
	// public item: VIPCapability | null = null;
	// public editCap = "edit_vip_capability";
	// public deleteCap = "delete_vip_capability";
	// public dbType = DBType.capabilities;
	// public rest = VIPCapabilityRest;
	// public redirection = { name: "Capabilities" };
	// public loadMessage = "Chargement de la capacité ...";
	// public getParams: IVIPCapabilityRestGetParams = {
	// 	options: {
	// 		certificates: {
	// 			certificate: {
	// 				project: true,
	// 				ips: true,
	// 			},
	// 		},
	// 		events: { event: true },
	// 	},
	// };
	// public focused = {};
	// public invalidFeedbacks = {};

	public types = VipCapabilityType;
	public statuses = VipCapabilityStatus;

	public type: VipCapabilityType | null = null;
	public status: VipCapabilityStatus | null = null;
	public certificate: VIPCertificate | null = null;
	public certificates: VIPCertificate[] = [];

	public get date(): Date | null {
		return this.item?.date?.toDate() || null;
	}
	public set date(value: Date | null) {
		if (this.item) {
			this.item.date = dayjs.nullable(value);
		}
	}

	public get rule(): IpRuleType {
		return this.item?.isTypeCustomary ? this.item?.ip?.exceptional ? "exceptional" : "customary" : "probationary";
	}

	public get ccs(): number[] {
		return this.item?.certificates.map(cc => cc.fk_certificate) || [];
	}
	public set ccs(value: number[]) {
		if (this.item) {
			value.forEach(fk_certificate => {
				if (!this.item?.certificates.find(cc => cc.fk_certificate === fk_certificate)) {
					db.capabilityCertificates.insert({
						fk_capability: this.item?.id,
						fk_certificate,
					});
				}
			});

			this.item.certificates.forEach(cc => {
				if (!value.find(fk_certificate => cc.fk_certificate === fk_certificate)) {
					db.capabilityCertificates.remove(cc, true);
				}
			});
		}
	}

	public get shouldTrash(): boolean {
		return this._item?.isSent || false;
	}

	public get canEdit(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.item.isDraft || false;
	}

	public get canCancel(): boolean {
		return this.canEdit && this.id > 0 && this.changed;
	}

	public get canSend(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && !this.isNew && this.item.isDraft || false;
	}

	public get canArchive(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && !this.isNew && (this.item.isSigned || this.item.isExpired) || false;
	}

	public get canSignCustomary(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.item.isSent && this.item.isTypeCustomary || false;
	}

	public get canSignProbationary(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.item.isSent || false;
	}

	public get canExtend(): boolean {
		if (!auth.user || !this.item) {
			return false;
		}

		return auth.user.capabilities.edit_vip_capability && this.item.isSigned && this.item.canExtend && !this.item.extension || false;
	}

	public get typeLabel(): string {
		return getVipCapabilityTypeLabel(this.type || this.item?.type || VipCapabilityType.probationary);
	}

	public removeMessageOption(shouldTrash: boolean = false): { message: string } & BvMsgBoxOptions {
		return {
			message: shouldTrash
				? "Êtes-vous sûr de vouloir refuser cette capacité ?"
				: "Êtes-vous sûr de vouloir supprimer cette capacité ?",
			title: shouldTrash ? "Refuser" : "Supprimer",
			cancelTitle: "Non",
			cancelVariant: "outline-secondary",
			okTitle: shouldTrash ? "Refuser" : "Supprimer",
			okVariant: shouldTrash ? "outline-danger" : "danger",
			centered: true,
		};
	}

	public changeStatus(status: VipCapabilityStatus, type?: VipCapabilityType) {
		if (this.item) {
			this.status = status;
			if (type) {
				this.type = type;
			}
			this.item.event = createEventInfo();
			this.$bvModal.show("sign_modal");
		}
	}

	public confirmChangeStatus(event: BvModalEvent) {
		if (this.item && this.status) {
			this.item.status = this.status;
			if (this.type) {
				this.item.type = this.type;
			}
			busy.start("Validation de la capacité ...");
			VIPCapabilityRest.changeStatus(this.item).then(result => {
				if (result.success) {
					this.$emit("saved", this.item);
					this.$root.$emit("vip-capability-saved", this.item);
				}
			}).finally(() => {
				busy.stop();
			});
			this.status = null;
			this.type = null;
		}
	}

	public filter(options: VIPCertificate[], search: string): VIPCertificate[] {
		return options.filter(c => c.project?.name.includes(search));
	}

	public save() {
		if (!this.item || !this.canEdit) {
			return;
		}
		if (!this.check()) {
			toaster.toast({ message: "Certaines informations ne sont pas valides.", variant: "warning", noAutoHide: false });
			return;
		}
		busy.start("Sauvegarde de la capacité ...");
		this.item.event = createEventInfo();
		let ids = this.item.certificates.map(cc => cc.fk_certificate);
		let isNew = this.isNew;
		let p = isNew ? VIPCapabilityRest.create : VIPCapabilityRest.update;
		p(this.item)
			.then(result => {
				if (result.success && result.item) {
					return VIPCapabilityCertificateRest.batch(result.item.id, ids);
				}
				return <any>result;
			}).then((result: IRestResult<VIPCapability> | IRestResult<VIPCapabilityCertificate[]>) => {
				if (result.success) {
					this.changed = false;
					this.unfocusAll();
					if (isNew) {
						this.$emit("created", this._item);
						this.$root.$emit("vip-capability-created", this._item);
					}
					this.$emit("saved", this.item);
					this.$root.$emit("vip-capability-saved", this.item);
					if (this.id < 0 && (this.item?.id || 0) > 0) {
						this.$router.push({ name: "Capability", params: { id: this.item?.id?.toString() || "" } });
					}
				}
			}).finally(() => {
				busy.stop();
			});
	}

	public extend() {
		if (!this.item || !this.canExtend) {
			return;
		}
		busy.start("Extension de la capacité ...");
		this.item.event = createEventInfo(VipEventType.extended);
		this.item.extension = true;
		VIPCapabilityRest.update(this.item).then(result => {
			if (result.success) {
				this.$root.$emit("vip-capability-saved", this.item);
			}
		}).finally(() => {
			busy.stop();
		});
	}

	public restore() {
		if (this.item?.isRefused && auth.user?.capabilities.edit_vip_capability) {
			this.item.status = VipCapabilityStatus.sent;
			this.save();
		}
	}

	public loadDependencies() {
		if (this.item) {
			if (!this.item.certificates.length) {
				VIPCapabilityCertificateRest.list(this.item.id, { options: { certificate: { project: true } } });
			}
			if (!this.item.events.length) {
				VIPCapabilityEventRest.list(this.item.id, { options: { event: true } });
			}
		}
	}

	public loadCertificates() {
		if (!this.item) {
			return;
		}

		let limit = this.item.isTypeCustomary
			? this.item.ip?.exceptional
				? settings.maxExceptionalLimit
				: settings.maxCustomaryLimit
			: settings.maxProbationaryLimit;
		let date = limit ? dayjs().subtract(limit, "years") : undefined;

		VIPCertificateRest.list({
			fk_ip: this.item.fk_ip,
			date: date ? { values: date.format("YYYY-MM-DD"), operator: ">", type: "date" } : undefined,
			type: VipCertificateType.workCertificate,
			per_page: 99,
			page: 1,
			orderby: "date",
			order: "DESC",
			options: {
				project: true
			}
		}).then(result => {
			this.certificates = result.items || [];
		});
	}

	public addCertificate() {
		if (this.item && this.certificate) {
			this.changed = true;
			db.capabilityCertificates.insert({ fk_capability: this.item.id, fk_certificate: this.certificate.id });
		}
	}

	public removeCertificate(cc: VIPCapabilityCertificate) {
		if (this.item && cc) {
			this.changed = true;
			db.capabilityCertificates.remove(cc, true);
		}
	}

	@Watch("item", { immediate: true })
	public itemChanged(newValue?: VIPCapability | null, oldValue?: VIPCapability | null) {
		if (newValue && newValue !== oldValue) {
			this.loadCertificates();
		}
	}
}
